import * as Html from "../../util/Html.ts";
import Icons from "../../svg/Icons.ts";

Html.registerWidget('widget/form/password',{initDom:initDom})

export function initDom(elem: HTMLElement) {
  elem.style.position = 'relative';

  const input = elem.querySelector('input') as HTMLInputElement | null;
  if (!input) return;

  //ensure there is space for icon
  input.style.paddingRight = '40px';

  const icon = document.createElement('icon');
  icon.setAttribute('aria-hidden', 'true');
  icon.style.cssText = [
    'position:absolute',
    'right:12px',
    'top:50%',
    'transform:translateY(-50%)',
    '-webkit-transform:translateY(-50%)',
    'cursor:pointer',
    'color:var(--fwTextSecondary)',
    '-webkit-tap-highlight-color:transparent'
  ].join(';');

  icon.innerHTML = Icons.ic_eye_off.toString();
  elem.appendChild(icon);

  icon.addEventListener('click', (evt) => {
    evt.stopPropagation();
    evt.preventDefault();

    const isPwd = input.type === 'password';
    icon.innerHTML = (isPwd ? Icons.ic_eye : Icons.ic_eye_off).toString();
    input.type = isPwd ? 'text' : 'password';
    input.focus();
  });
}